'use strict';

var dialog = require('../../dialog');
var util = require('../../util');
var imagesLoaded = require('imagesloaded');
var qs = require('qs');
var url = require('url');
var _ = require('lodash');

var zoomMediaQuery = matchMedia('(min-width: 768px)');

// Global variable to track viewport-changes
var _viewPortWidth = util.getViewPortWidth();
var _viewPort;

/**
 * @description Enables the zoom viewer on the product detail page
 * @param zmq {Media Query List}
 */

function initializeEvelateZoom(container) {
	if(!($(".product-col-1").hasClass("e-giftcard-detail") || $(".product-col-1").hasClass("giftcard-detail"))) {
		imagesLoaded(container).on('done', function() {
			var zoomWidth = 438;
			var $container = $(container);
			var zoomHeight = $container.height();
			var zoomContainerX = 76;
			var extraClsZoomContainer ="";
			var zoomLevelFlag= 1.2;
			var zoomPosition = '';
			var $ZoomLengthCount = '';
			//var zoomHeight = $(".product-col-1").find(".product-primary-image").height();
			if($("#QuickViewDialog").closest(".ui-dialog ").is(":visible")) {
				zoomContainerX = 40;
				zoomLevelFlag=.880;
				extraClsZoomContainer = "js-zoom-container";
				if($(".pdp-main").hasClass("standardproductset")) {
					$(".product-set-item .set-zoom-container-id").removeAttr("id");
					$(".product-set-item.selected .set-zoom-container-id").attr("id","zoom-image-container");
					zoomWidth = $(".product-set-item.selected .set-zoom-container-id").width();
				} else {
					zoomWidth = $(".pdp-main").find("#zoom-image-container").width();
				}
			}
			if ($('#wrapper').hasClass('quick-order-page')) {
				$('.product-col-2.product-quickorder-detail').each(function() {
					$ZoomLengthCount = $(this).attr('data-count');
					zoomPosition = $ZoomLengthCount;
				});
				extraClsZoomContainer = "js-quickorder-zoom-container";
				zoomWidth = $('.pdp-main').find('.product-quickorder-detail').width();
				zoomHeight = 670;
			} else {
				zoomPosition= "zoom-image-container";
			}
			if($('.pdp-max-width').hasClass('bh-zoom-image-container') && $('#wrapper').hasClass('pt_product-details')) {
				zoomWidth = 560;
				zoomHeight = 560;
			}
			$.removeData(container, 'elevateZoom');//remove zoom instance from image
			$("body").find(".zoomWindowContainer, .zoomContainer").remove();
			$container.elevateZoom({
				responsive: false,
				borderSize: 0,
				zoomWindowWidth: zoomWidth,
				zoomWindowHeight: zoomHeight,      // 1.3125 is the ratio of the zoom lens height to width in the comps (105/80)
				zoomWindowPosition: zoomPosition,
				borderColour: "#FFFFFF",
				zoomLevel: zoomLevelFlag,
				lensSize: 400
			});
			setTimeout(function(){
				if ($('#wrapper').hasClass('quick-order-page')) {
					$('body').addClass(extraClsZoomContainer);
				} else {
					$(".zoomContainer").addClass(extraClsZoomContainer);
				}
			}, 1000);
		});
	}

}
function loadZoom (zmq) {
	var imgZoom = '#pdpMain .main-image';
    var $imgZoom = $(imgZoom),
        hiresUrl = $imgZoom.attr('href');
    if (!zmq) {
        zmq = zoomMediaQuery;
    }

    if (util.isMobile() && $(window).width() <= 1024) {
        // remove zoom
        $imgZoom.trigger('zoom.destroy');
        var imageContainer;
        imageContainer = ".product-col-1 .thumb .thumbnail-link";
        if( $(".pdp-main").hasClass("standardproductset") ) {
        	imageContainer = ".product-col-1-productdetail .thumb .thumbnail-link";
    	}
        var $imageContainer = $(imageContainer);
        //$imageContainer.unwrap(".pinch-zoom-container");
        if($(window).width() < 768) {
        	imagesLoaded(imageContainer).on('always', function() {
        		$imageContainer.each(function () {
					if(!$(this).parent().hasClass('pinch-zoom-container')){
						new RTP.PinchZoom($(this), {});
						$(this).find('img').removeClass('hide-mobile');
					}
                 });
        	});

        } else {
        	imagesLoaded(imgZoom).on('done', function() {
        		$imgZoom.each(function () {
					new RTP.PinchZoom($(this), {});
					$(this).find('img').removeClass('hide-tablet');
                 });
        	});

        }
		$imageContainer.off("click").on("click", function(e) {
			e.preventDefault()
		});
        return;
    } else {
    	if( $("#wrapper").hasClass("pt_product-details") ) {
    		var container = '.product-col-1 img.primary-image';
			initializeEvelateZoom(container);
    	} else if($("#QuickViewDialog").length > 0){
    		var $pdpMain = $("#QuickViewDialog").find(".pdp-main");
    		if( $pdpMain.hasClass("standardproductset")){
    			var container = '.product-set-item.selected img.product-set-main-image';
    			if( !($(container).length > 0) ) {
    				container = '.product-set-item.selected .product-primary-image img.primary-image';
    			}
				initializeEvelateZoom(container);
    		} else if($pdpMain.hasClass("standardproduct")){
    			var container = '.product-col-1 img.primary-image';
				initializeEvelateZoom(container);
    		} else if($pdpMain.hasClass("specialproductset")) {
    			var container = '.product-col-1.product-bundle img.primary-image';
				initializeEvelateZoom(container);
    		}
    	} else if( $('#wrapper').hasClass('quick-order-page') ) {
    		var container = '.product-col-1 img.primary-image-quick-order';
			initializeEvelateZoom(container);
    	}
    }
}


function initializeVideo() {
    //youtube video settings
    var $productVideoContainer = $('.product-video-container');
	var $videoOpenLink = $('.enlarge-video.video-link');
	var $thumblineImage = $(".enlarge-video-sec").next(".product-thumbnails");
	var $prodPrimaryImageCont = $('.product-primary-image');
    if ($productVideoContainer.length) {
    	$('.enlarge-video.video-link').addClass('visible');
    	$('body').off('click','.enlarge-video.video-link').on('click','.enlarge-video.video-link',function(e) {
	    	e.preventDefault();
	    	if(!$productVideoContainer.is(":visible")) {
	    		$productVideoContainer.height($('.product-image-container .product-primary-image').height());
	    		$("body").find(".zoomWindowContainer, .zoomContainer").remove();
	    	if( $(window).width() < 768 ) {
	    		$productVideoContainer.height($('.product-thumbnails .slick-list .thumbnail-link img').height());
	    	}
	    	$productVideoContainer.show();
	    		$('.product-primary-image .b_product_badge').removeClass("js-show").addClass("js-hide");
	    	}
    	 });
	}
}

zoomMediaQuery.addListener(loadZoom);

/**
 * @description Sets the Catalog Quick Order main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url imageContainer Object with image container of CQO line item, alt, title and hires properties
 */

function setCQOMainImage(atts, imageContainer) {

    // Update the product's primary image
    $(imageContainer).find('.primary-image-quick-order').attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title
    });

    // Include logic to generate a 404 productImage (if the image doesn't load)
    $(imageContainer).find('.primary-image-quick-order').on('error', function () {
        $(this).attr('src', window.product404Images.largeImage);
    });

    // Only update the hires image if the hires url is provided
    if (atts.hasOwnProperty('hires')) {
        // Update the zoom-image with the hi-res url
    	$(imageContainer).find('.primary-image-quick-order').data('zoom-image',atts.hires);
    	updatePinButton(atts.url);
        loadZoom();
    }
}
/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage(atts) {
    // Hide liveclicker video
    if ($(window).width() > 767) {
        $('#lc_player_box').hide();
        $('#pdpMain .product-image').show();
	}
	
    // Update the product's primary image
    $('#pdpMain .primary-image').attr({
        src: atts.url,
        alt: atts.alt,
		title: atts.title,
		"data-isimagesameasmasterproduct": atts.isimagesameasmasterproduct
    });

    // Include logic to generate a 404 productImage (if the image doesn't load)
    $('#pdpMain .primary-image').on('error', function () {
        $(this).attr('src', window.product404Images.largeImage);
    });

    // Only update the hires image if the hires url is provided
    if (atts.hasOwnProperty('hires')) {
        // Update the zoom-image with the hi-res url
    	$('#pdpMain .primary-image').data('zoom-image',atts.hires);
        updatePinButton(atts.url);
        loadZoom();
    }
}

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag for a given productSet pdp image
 * @param {Object} $mainImage jQuery reference to the image being updated
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setPSMainImage($mainImage, atts) {
    // Update the product's primary image
    $mainImage.attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title
    });
}

function updatePinButton (imageUrl) {
    var pinButton = document.querySelector('.share-icon[data-share=pinterest]');
    if (!pinButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    var href = url.parse(pinButton.href);
    var query = qs.parse(href.query);
    query.media = url.resolve(window.location.href, newUrl);
    query.url = window.location.href;
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    pinButton.href = newHref;
}
/**
 * @description Alernate images slider events.
 */
var slickConfig = {
		slidesToShow: 4.5,
		slidesToScroll: 1,
		dots: false,
		infinite: false,
		initialSlide: 0,
		responsive: [
			{
			  breakpoint: 1023,
			  settings: {
				  slidesToShow: 4,
				  slidesToScroll: 1,
				  dots: false,
				  infinite: false,
				  initialSlide: 0
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
}
var bhSlickConfig = {
	slidesToShow: 6,
	slidesToScroll: 1,
	dots: false,
	infinite: false,
	initialSlide: 0,
	responsive: [
		{
		  breakpoint: 1023,
		  settings: {
			  slidesToShow: 4,
			  slidesToScroll: 1,
			  dots: false,
			  infinite: false,
			  initialSlide: 0
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true
		  }
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
}
var slickConfigPS = {
	slidesToShow: 3,
	slidesToScroll: 1,
	dots: false,
	infinite: false,
	initialSlide: 0,
	responsive: [
		{
		  breakpoint: 1023,
		  settings: {
			  slidesToShow: 3,
			  slidesToScroll: 1,
			  dots: false,
			  infinite: false,
			  initialSlide: 0
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true
		  }
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
}
var qvSlickConfig = {
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		infinite: false,
		initialSlide: 0,
		responsive: [
			{
			  breakpoint: 1023,
			  settings: {
				  slidesToShow: 4,
				  slidesToScroll: 1,
				  dots: false,
				  infinite: false,
				  initialSlide: 0
			  }
			},
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
}
var bhQvSlickConfig = {
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		infinite: false,
		initialSlide: 0,
		responsive: [
			{
			  breakpoint: 1023,
			  settings: {
				  slidesToShow: 3,
				  slidesToScroll: 1,
				  dots: false,
				  infinite: false,
				  initialSlide: 0
			  }
			},
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
}
function alternateImageSlider () {
	var $productThumbnails = $(".product-col-1 .product-thumbnails"),
		$productSetThumbnails = $(".product-set-item.selected .product-thumbnails");
	if( $(".pdp-main").hasClass("standardproductset")){
		$productThumbnails = $(".product-col-1 .product-thumbnails ul.ps-thumbline-image-list");
	}
	if( $("#wrapper").hasClass("pt_product-details") ) {
		if($productThumbnails.hasClass("slick-initialized")) {
			$productThumbnails.slick("unslick");
		}
		$productThumbnails.each(function(){
			var $curObj = $(this);
			if( $curObj.children().length > 0 ){
				// wraps slick arrows with <li> tags after slick initialization.
				$curObj.on('init breakpoint', function(){
					if($curObj.prop('nodeName') == 'UL')
					$($curObj.children("button.slick-prev, button.slick-next")).wrap("<li></li>");
				});
				if( $(".pdp-main").hasClass("standardproductset")){
					$curObj.slick(slickConfigPS);
				} else {
					if ($curObj.hasClass("bh-thumbnails")) {
						$curObj.slick(bhSlickConfig);
					}
					else {
						$curObj.slick(slickConfig);
					}
				}
				$curObj.on('afterChange', function(event, slick, currentSlide, nextSlide){
					var $productVideoContainer = $('.product-video-container');
					var firstThumbActive = $(".product-col-1").find(".slick-slide")[0];
					if($productVideoContainer.is(":visible")) {
						var $videoOpenLink = $('.enlarge-video.video-link');
						var $thumblineImage = $(".enlarge-video-sec").next(".product-thumbnails"),
							$thumbSelected = $thumblineImage.find(".thumb.slick-current");
		                    $('.product-image.main-image').hide();
		                    $productVideoContainer.closest(".product-primary-image").removeAttr("style");
					    	$thumblineImage.find(".thumb").show();
			                $productVideoContainer.hide();
					}
					//loadZoom();
					if($(firstThumbActive).hasClass("slick-active")){
						$('.product-primary-image .b_product_badge').removeClass("js-hide").addClass("js-show");
					}
					else {
						$('.product-primary-image .b_product_badge').removeClass("js-show").addClass("js-hide");
				    }
				});
			}
		});
		if( $(".pdp-main").hasClass("standardproductset")){
			if( $(".product-col-1 .product-col-1-productdetail .product-thumbnails").hasClass("slick-initialized")){
				 	$(".product-col-1 .product-col-1-productdetail .product-thumbnails").slick("unslick");
			}

			if($(window).width() < 768) {
				if( $(".product-col-1 .product-thumbnails ul.ps-thumbline-image-list").hasClass("slick-initialized")){
					$(".product-col-1 .product-thumbnails ul.ps-thumbline-image-list").slick("unslick");
				}

				$(".product-col-1 .product-thumbnails ul.ps-thumbline-image-list").each(function(){
					var $curObj = $(this);
					if( $curObj.children().length > 0 ){
						if ($curObj.hasClass("bh-thumbnails")) {
							$curObj.slick(bhSlickConfig);
						}
						else {
							$curObj.slick(slickConfig);
						}
					}
				});
			}
		}

	} else if($("#QuickViewDialog").length > 0){
		var $pdpMain = $("#QuickViewDialog").find(".pdp-main");
		if( $pdpMain.hasClass("standardproductset") || $pdpMain.hasClass("specialproductset") || $pdpMain.hasClass("productbundle") ){
			if( $pdpMain.hasClass("specialproductset")) {
				if($productThumbnails.hasClass("slick-initialized")) {
					$productThumbnails.slick("unslick");
				}
				$productThumbnails.each(function(){
					var $curObj = $(this);
					if( $curObj.children().length > 0 ){
						if($productThumbnails.hasClass('bh-qv-product-thumbnails')) {
							$curObj.slick(bhQvSlickConfig);
						} else {
							$curObj.slick(qvSlickConfig);
						}
						$curObj.on('afterChange', function(event, slick, currentSlide, nextSlide){
							var $productVideoContainer = $('.product-video-container');
							var firstThumbSelected = $productVideoContainer.closest(".product-col-1").find(".thumb").eq(0).hasClass("selected");
							if($productVideoContainer.is(":visible")) {
								var $videoOpenLink = $('.enlarge-video.video-link');
								var $thumblineImage = $(".enlarge-video-sec").next(".product-thumbnails"),
									$thumbSelected = $thumblineImage.find(".thumb.slick-current");
				                    $('.product-image.main-image').hide();
				                    $productVideoContainer.closest(".product-primary-image").removeAttr("style");
							    	$thumblineImage.find(".thumb").show();
					                $productVideoContainer.hide();
							}
							//loadZoom();
							if(firstThumbSelected){
								$('.product-primary-image .b_product_badge').removeClass("js-hide").addClass("js-show");
							}
							else {
								$('.product-primary-image .b_product_badge').removeClass("js-show").addClass("js-hide");
						    }
						});
					}
				});
			}
			if($productSetThumbnails.hasClass("slick-initialized")) {
				$productSetThumbnails.slick("unslick");
			}
			if($productSetThumbnails.hasClass('bh-qv-product-thumbnails')) {
				$productSetThumbnails.slick(bhQvSlickConfig);
			} else {
				$productSetThumbnails.slick(qvSlickConfig);
			}
			$productSetThumbnails.on('afterChange', function(event, slick, currentSlide, nextSlide){
				var $productVideoContainer = $('.product-video-container');
				var firstThumbSelected = $productVideoContainer.closest(".product-col-1").find(".thumb").eq(0).hasClass("selected");
				if($productVideoContainer.is(":visible")) {
					var $videoOpenLink = $('.enlarge-video.video-link');
					var $thumblineImage = $(".enlarge-video-sec").next(".product-thumbnails"),
						$thumbSelected = $thumblineImage.find(".thumb.slick-current");
	                    $('.product-image.main-image').hide();
	                    $productVideoContainer.closest(".product-primary-image").removeAttr("style");
				    	$thumblineImage.find(".thumb").show();
		                $productVideoContainer.hide();
		                if(firstThumbSelected){
							$('.product-primary-image .b_product_badge').removeClass("js-hide").addClass("js-show");
						}
						else {
							$('.product-primary-image .b_product_badge').removeClass("js-show").addClass("js-hide");
					    }
				}

				//loadZoom();
			});
		} else if($pdpMain.hasClass("standardproduct")){
			if($productThumbnails.hasClass("slick-initialized")) {
				$productThumbnails.slick("unslick");
			}
			if($productThumbnails.hasClass('bh-qv-product-thumbnails')) {
				$productThumbnails.slick(bhQvSlickConfig);
			} else {
				$productThumbnails.slick(qvSlickConfig);
			}
			$productThumbnails.on('afterChange', function(event, slick, currentSlide, nextSlide){
				var $productVideoContainer = $('.product-video-container');
				var firstThumbSelected = $productVideoContainer.closest(".product-col-1").find(".thumb").eq(0).hasClass("selected");
				if($productVideoContainer.is(":visible")) {
					var $videoOpenLink = $('.enlarge-video.video-link');
					var $thumblineImage = $(".enlarge-video-sec").next(".product-thumbnails"),
						$thumbSelected = $thumblineImage.find(".thumb.slick-current");
	                    $('.product-image.main-image').hide();
				    	$productVideoContainer.closest(".product-primary-image").removeAttr("style");
				    	$thumblineImage.find(".thumb").show();
		                $productVideoContainer.hide();
		                if(firstThumbSelected){
							$('.product-primary-image .b_product_badge').removeClass("js-hide").addClass("js-show");
						}
						else {
							$('.product-primary-image .b_product_badge').removeClass("js-show").addClass("js-hide");
					    }
				}

				//loadZoom();
			});
		}
	}

	// moves a (non-QuickView) alternate image slide into view if it was partially hidden when clicked
	$productThumbnails.not('#QuickViewDialog .product-thumbnails').on('click','.slick-slide',function(){
		var index = $(this).attr('data-slick-index');
		var slideOffset = $(this).offset();
		var slidePos = $(this).position();
		var slideWidth = $(this).width();
		if(slidePos.left + slideWidth + $('.slick-track').position().left > $productThumbnails.width()){
			//slide is far right and truncated
			$productThumbnails.find('button.slick-next').click();
		}
		else if(slideOffset.left < $productThumbnails.offset().left){
			//slide is far left and truncated
			$productThumbnails.find('button.slick-prev').click();
		}
	});

	$productThumbnails.addClass("remove-ht-ovr-hidden");
	if( $("#wrapper").hasClass("pt_product-details") ) {
		if( $productThumbnails.find(".slick-arrow").length >  0 ) {
			$productThumbnails.addClass("slick-arrow-bar");
		}
	} else if($("#QuickViewDialog").length > 0){
		var $pdpMain = $("#QuickViewDialog").find(".pdp-main");
		if( $pdpMain.hasClass("standardproductset") || $pdpMain.hasClass("specialproductset") || $pdpMain.hasClass("productbundle") ){
			if($productSetThumbnails.find(".slick-arrow").length >  0 ) {
				$productSetThumbnails.addClass("slick-arrow-bar");
			}
		} else if($pdpMain.hasClass("standardproduct")){
			if( $productThumbnails.find(".slick-arrow").length >  0 ) {
				$productThumbnails.addClass("slick-arrow-bar");
			}
		}
	}
	// SM-6073
	var	$imageContainer = $('#pdpMain .product-image-container');
	imagesLoaded($imageContainer).on('always', function() {
		$imageContainer.removeClass('visible-hidden');
	    $imageContainer.css({'height': 'auto'});
	});
	//On quick view dialog
	if ($('.ui-dialog.quick-view').is(':visible')) {
		util.loadSrollForQVProduct();
	}

	//calling scroll for variation select
	if($('.product-set-quickview').is(':visible')){
		loadsrollforsetproduct();
	}
}
/**
 * @description Replaces the images in the image container, for eg. when a different color was clicked.
 */
function replaceImages () {
    var $newImages = $('#update-images');
	var	$imageContainer = $('#pdpMain .product-image-container');
	var $mainImage = $newImages.find('.product-primary-image .main-image img');
    if ($newImages.length === 0) { return; }
	// when new image is NOT SAME as the container image, only then update to the new image.
	if($imageContainer.find('img.primary-image').attr('src').indexOf(findImgFromLongURL($newImages.find('.primary-image').attr('src'))) == -1){
		// SM-6073
		var imageSectionHeight = $imageContainer.height();
		$imageContainer.addClass('visible-hidden');
		$imageContainer.css({'height': imageSectionHeight+'px'});
		$imageContainer.html($newImages.html());
	}
    $newImages.remove();
	//  Prepend the main image to the thumbnail in mobile site, when a different color was clicked.
    var $thumbLine = $imageContainer.find('.product-thumbnails .thumb img.productthumbnail');
	if ($(window).width() < 768) {
		var imageSectionHeight = $imageContainer.height();
		$imageContainer.addClass('visible-hidden');
		$imageContainer.css({'height': imageSectionHeight+'px'});
		$imageContainer.html($newImages.html());
		if($thumbLine.length > 0) {
			if($thumbLine.first().attr('data-mobile-src').indexOf(findImgFromLongURL($mainImage.attr('data-replaceimage'))) == -1){
				$imageContainer.find('.product-thumbnails').prepend(
					"<div class='thumb background-thumb'>" +
					"<a name='product_detail_image' class='thumbnail-link'>" +
					$mainImage[0].outerHTML
					+ "</a>"+ "</div>"
				);
			}
		}
	}
	loadZoom();
	initializeVideo();
}

/**
 * @description it's a helper to cut image from yottaa url
 */
function findImgFromLongURL(imgUrl) {
    if (!imgUrl) return;
    var imgStart = imgUrl.indexOf('/images/');
    var imgEnd = imgUrl.indexOf('.', imgStart);
    var img = imgUrl;
    if (imgStart > -1 && imgEnd > -1) {
        img = imgUrl.substring(imgStart, imgEnd);
    }
    return img;
}
/**
 * @description Replaces the images in the image container in Catalog quick order page, for eg. when a different color was clicked.
 * @param {$pdpForm} will have current line item container form, with that we can find the current image container that need to be replaced.
 */
function replaceImagesCQO ($pdpForm) {
    var $newImages = $pdpForm.find('#update-images');
	var $imageContainer = $pdpForm.find('.product-col-1.product-image-container');
	var $mainImage = $newImages.find('.product-primary-image .main-image img');
    if ($newImages.length === 0) { return; }

    $imageContainer.height($imageContainer.height());
	$imageContainer.html($newImages.html());
	$newImages.remove();
		//  Prepend the main image to the thumbnail in mobile site, when a different color was clicked.
	var $thumbLine = $imageContainer.find('.product-thumbnails .thumb img.productthumbnail');
	if ($(window).width() < 768) {
		if($thumbLine.length > 0) {
			if($thumbLine.first().attr('data-mobile-src').indexOf($mainImage.attr('data-replaceimage')) == -1){
				$imageContainer.find('.product-thumbnails').prepend(
					"<div class='thumb background-thumb'>" +
					"<a name='product_detail_image' class='thumbnail-link'>" +
					$mainImage[0].outerHTML
					+ "</a>"+ "</div>"
				)
			}
		}
	}
	loadZoom();
}
function loadsrollforsetproduct () {
	if($('.product-set-item.selected .qv-productset-scrollbar').height() > 430) {
		$('.product-set-item.selected .qv-productset-scrollbar').slimScroll({
	    	height: '430px',
	    	railVisible: true,
			color: "#f4f4f4",
			railColor: "#ffffff",
	        railOpacity: 1,
	        size: '10px',
	        allowPageScroll: false,
	        alwaysVisible: true
	    });
	}
}

/**
 * @function renderResponsiveThumbnailRailImages
 * @description for the thumbnail rail -- dynamically determine what image-size to render and then
 * render the images in the thumbnail rail
 *
 * @param {Boolean} forceRender Flag which controls whether the thumbnail rendering should be forced or
 * driven by the viewPort width (we use the force specifically when a new variant is selected)
 */
function renderResponsiveThumbnailRailImages(forceRender,$currentForm) {

    // If the viewPort has not changed -- then exit early
    var viewPortProperties = util.getViewPort();
    var lookupKey = 'desktop-src';

    // Exit early if the view-ports don't match (and that we're not manually forcing a render)
    if (_viewPort === viewPortProperties.viewPort && forceRender !== true) { return; }

    // Cache the current viewPort
    _viewPort = viewPortProperties.viewPort;

    if (viewPortProperties.viewPort === 'mobile' || viewPortProperties.viewPort === 'tablet') {
        lookupKey = 'mobile-src';
    }

    // Retrieve the full collection of product-images displayed in the thumbnail rail
    var $productImages = $('div.product-thumbnails img.productthumbnail, .enlarge-thumb-image img.productthumbnail, .enlarge-hero-container img.productthumbnail');

    if($currentForm != undefined && $currentForm != null && $currentForm.length > 0) {
    	$productImages = $currentForm.find('div.product-thumbnails img.productthumbnail, .enlarge-thumb-image img.productthumbnail, .enlarge-hero-container img.productthumbnail');
    }
    // Loop over the collection of images found
    $productImages.each(function (elementIndex, productImage) {

        // Create a jQuery reference to the current image
        var $thisImage = $(productImage);

        // Render the product-image using the look-up key specified
        $thisImage.attr('src', $thisImage.data(lookupKey));

    });

}

var slickConfigCQO = {
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		infinite: false,
		initialSlide: 0,
		responsive: [
			{
			  breakpoint: 1023,
			  settings: {
				  slidesToShow: 2.5,
				  slidesToScroll: 1,
				  dots: false,
				  infinite: false,
				  initialSlide: 0
			  }
			},
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
}
/**
 * @function alternateImageSliderCQO
 * @description for the thumbnail slider initialization
 */
function alternateImageSliderCQO() {
	var $productThumbnails = $(".product-col-1 .product-thumbnails");
	$productThumbnails.each(function(){
		var $curObj = $(this);
		if($curObj.hasClass("slick-initialized")) {
			$curObj.slick("unslick");
		}
		if( $curObj.children().length > 0 ){
			$curObj.slick(slickConfigCQO);
		}
		if( $curObj.find(".slick-arrow").length >  0 ) {
			$curObj.addClass("slick-arrow-bar");
		}
		$productThumbnails.addClass("remove-ht-ovr-hidden");
	});
}

/**
 * @function lazyLoadImages
 * @description lazyLoadImages
 * $image is the image selector
 **/
function lazyLoadImages($image) {
	if (!$image){ return };
	$image.unveil();
}
/**
/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
    var $quickView = $('#QuickViewDialog');
    if (util.isMobile()) {
        $('#pdpMain .main-image').removeAttr('href');
    } else {
    	$(".product-primary-image").addClass("not-a-device");
	}
	//prepend the preselected image to the alt image trail if in mobile site
    //Avoiding this if condition for CQO to resolve SM-6048
    var cqoPage = $('.catalog-quick-order-content').length > 0; 
	if ($(window).width() < 768 && !cqoPage) {
		var $mainImage = $(".product-primary-image .main-image img");
		var	$imageContainer = $('#pdpMain .product-image-container');
		if($('.pdp-main').hasClass('standardproductset')){
			$imageContainer = $('#pdpMain .bh-product-col-1-productdetail');
		}
		//if selected image is same with product main image
		var $thumbLine = $imageContainer.find('.product-thumbnails .thumb img.productthumbnail');
		if($thumbLine.length > 0) {
			if($thumbLine.first().attr('data-mobile-src').indexOf($mainImage.attr('data-replaceimage')) == -1){
				$imageContainer.find('.product-thumbnails').prepend(
					"<div class='thumb background-thumb'>" +
					"<a name='product_detail_image' class='thumbnail-link'>" +
					$mainImage[0].outerHTML
					+ "</a>"+ "</div>"
				)
			}
		}
	}
	lazyLoadImages($('.pdp-main img'));
	//force trigger lazyload
	$(window).resize();
    updatePinButton();
    loadZoom();
	initializeVideo();
	if( $("#wrapper").hasClass("quick-order-page") ) {
		alternateImageSliderCQO();
    }
    // Bypass loading the image-slider logic on quickView
	imagesLoaded('.product-col-1').on('always', function() {
		if ($quickView.length >= 0) {
			alternateImageSlider();
		}
	});

    // handle product thumbnail click event
    $('#pdpMain').on('click', '.productthumbnail', function () {
    	// switch indicator
    	if( $(window).width() > 767 ) {
    		$('.product-image.main-image').show();
		}
    	var productIdOld = $(this).closest('.product-thumbnails').find('.thumb.selected').find('.productthumbnail').data('setproductid');
        $(this).closest('.product-thumbnails').find('.thumb.selected').removeClass('selected');
        $(this).closest('.thumb').addClass('selected');
        if( $("#wrapper").hasClass("quick-order-page") ) {
        	var imageContainer = $(this).closest(".product-primary-image");
        	setCQOMainImage($(this).data('lgimg'),imageContainer);
        } else {
        	if($("#QuickViewDialog").length==0){
        		if( $(window).width() > 767 ) {
        			setMainImage($(this).data('lgimg'));
        		}
            }else{
            	var productIdNew = $(this).closest('.product-thumbnails').find('.thumb.selected').find('.productthumbnail').data('setproductid');
            	$(this).closest('.product-thumbnails').find('.thumb.selected').closest('#pdpMain').find('#item-'+productIdOld).removeClass('selected');
            	$(this).closest('.product-thumbnails').find('.thumb.selected').closest('#pdpMain').find('#item-'+productIdNew).addClass('selected');
            	setMainImage($(this).data('lgimg'));
            	if($("#pdpMain").hasClass("standardproductset")) {
            		alternateImageSlider();
            	}
            }
          //on click of product set thumb, checks whether to add scroll bar or not
            loadsrollforsetproduct();
            if ($('.ui-dialog.quick-view').is(':visible')) {
            	util.loadSrollForQVProduct();
            }
        }

    });
};
module.exports.loadZoom = loadZoom;
module.exports.setMainImage = setMainImage;
module.exports.replaceImages = replaceImages;
module.exports.replaceImagesCQO = replaceImagesCQO;
module.exports.alternateImageSlider = alternateImageSlider;
module.exports.alternateImageSliderCQO = alternateImageSliderCQO;
module.exports.loadsRollForSetProduct = loadsrollforsetproduct;
module.exports.setPSMainImage = setPSMainImage;
module.exports.renderResponsiveThumbnailRailImages = renderResponsiveThumbnailRailImages;
module.exports.lazyLoadImages = lazyLoadImages;
module.exports.initializeVideo = initializeVideo;